

enum ReferenceData {
    ActionToCustomer = "ActionToCustomer",
    Defect = "Defect",
    SubDefect = "SubDefect",
    DefectCause = "DefectCause",
    InternalAction = "InternalAction",
    Supplier = "Supplier",
    Country = "Country"
}

export default ReferenceData